import { render, staticRenderFns } from "./showAccuracy.vue?vue&type=template&id=10cd53d0&scoped=true&lang=html&"
import script from "./showAccuracy.vue?vue&type=script&lang=js&"
export * from "./showAccuracy.vue?vue&type=script&lang=js&"
import style0 from "./showAccuracy.vue?vue&type=style&index=0&id=10cd53d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd53d0",
  null
  
)

export default component.exports